import { AlertColor } from "@mui/material";
import { JSONContent } from "@tiptap/core";

import { ObjectKeys, Serialized } from "./generic";
import { UserBase } from "./identities";

export const BannerDisplayModeLabel = {
  dismissable: "Dismissable",
  always_displayed: "Always Displayed",
} as const;
export type BannerDisplayMode = ObjectKeys<typeof BannerDisplayModeLabel>;

export const BannerStatusLabel = {
  enabled: "Enabled",
  disabled: "Disabled",
} as const;
export type BannerStatus = ObjectKeys<typeof BannerStatusLabel>;

export const BannerPriorityLabel = {
  low: "Low",
  medium: "Medium",
  high: "High",
} as const;
export type BannerPriority = ObjectKeys<typeof BannerPriorityLabel>;

export const BannerPriorityToSeverity: Record<BannerPriority, AlertColor> = {
  low: "info",
  medium: "warning",
  high: "error",
} as const;

export type SerializedBannerContent = Serialized<JSONContent>;

/**
 * The base banner type that contains the common fields for both editable and non-editable banners.
 */
export type BaseBanner = {
  Title?: string | null;
  /**
   * A JSON serialised representation of the banner content (a Tiptap {@link JSONContent} object)
   */
  Content: SerializedBannerContent;
  DisplayMode: BannerDisplayMode;
  Priority: BannerPriority;
};

/**
 * The public interface for a banner that is returned from the API.
 */
export type Banner = BaseBanner & {
  ID: string;
  LastModifiedAt: string;
};

/**
 * An editable banner type that represents additional editable fields.
 */
export type EditableBanner = BaseBanner & {
  ID: string;
  Status: BannerStatus;
};

/**
 * A superuser banner type that includes all fields, including those for editing and metadata.
 */
export type SuperuserBanner = Banner &
  EditableBanner & {
    Owner: UserBase;
    Creator: UserBase;
    LastModifiedBy: UserBase;
  };
